import styled from 'styled-components';

export const SaveButtonFixed = styled.div`
  position: fixed;
  width: 150px;
  bottom: 25px;
  right: 25px;
  z-index: 1000;
`;